module.exports = __webpack_public_path__ + "static/img/wiseway.6412eb72.png";